/** Resolve apenas o badge de apresentação; nunca escolhe o canal de envio. */
export type ContactDisplayChannel = 'waha' | 'official_whatsapp' | 'instagram';

const recognized = (value?: string | null): value is ContactDisplayChannel =>
  value === 'waha' || value === 'official_whatsapp' || value === 'instagram';

export function resolveContactDisplayChannel(
  activeChannel?: string | null,
  lastMessageSourceChannel?: string | null,
): ContactDisplayChannel | undefined {
  if (recognized(activeChannel)) return activeChannel;
  if (recognized(lastMessageSourceChannel)) return lastMessageSourceChannel;
  return undefined;
}
